"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CacheKeyVO {
    constructor(userId, date) {
        this.userId = userId;
        this.date = date;
        this.getActivitiesKey = () => `SPORT_ACTIVITIES.${this.userId}.${this.date}`;
        this.getActivitiesPerDateKey = () => `SPORT_ACTIVITIES_PER_DATE.${this.userId}.${this.date}`;
    }
}
exports.default = CacheKeyVO;
CacheKeyVO.getActivitiesKeyFromPartial = (userId) => (date) => {
    return new CacheKeyVO(userId, date).getActivitiesKey();
};
CacheKeyVO.getActivitiesPerDateKeyFromPartial = (userId) => (date) => {
    return new CacheKeyVO(userId, date).getActivitiesPerDateKey();
};
CacheKeyVO.getDateFromKey = (cacheKey) => cacheKey.split(".")[2];
//# sourceMappingURL=CacheKeyVO.js.map